import script from "./Progress.vue?vue&type=script&lang=ts&setup=true"
export * from "./Progress.vue?vue&type=script&lang=ts&setup=true"

import "./Progress.vue?vue&type=style&index=0&id=709a237e&scoped=true&lang=css"

import exportComponent from "/data/jenkins/workspace/jet/cbt/production/deploy-cbt/exam/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-709a237e"]])

export default __exports__